module.exports = " <a href=https://wa.me/523327482493 target=_blank class=whatsapp> <div class=\"fa fa-whatsapp\"></div> </a> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Whatsapp.vue
// module id = 567
// module chunks = 0